
<template>
    <div class="center tablaAlumnos">
        <vs-button
            v-if="users[0]"
            class="ml-auto"
            success
            flat
            @click="activeMasivo =! activeMasivo"
        >
        <i class="fas fa-users mr-2"></i> Crear accesos masivamente
      </vs-button>
      <h6 v-if="total != ''">Numero total: {{total}}</h6>
      <vs-table>
        <template #thead>
          <vs-tr>
            <vs-th>
                Alumnos
            </vs-th>
            <vs-th>
                Cuentas asociadas
            </vs-th>
            <vs-th>
                Acceso de alumno
            </vs-th>
            <vs-th>
                Correo de recuperación
            </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="i"
            v-for="(tr, i) in users"
            :data="tr"
            class="divisionLineas"
          >
            <vs-td>
                <p class="mb-1"><strong>{{ tr.apellido_paterno + ' ' + tr.apellido_materno + ' ' + tr.nombres}}</strong></p>
                <p class="mb-0"><small>MATRÍCULA </small> </p>
                <p class="mb-1"><strong>{{ tr.matricula }}</strong></p>
                <p class="mb-0"><small>CORREO DE CONTACTO</small> </p>
                <p class="mb-1"><strong>{{ tr.correo }}</strong></p>
            </vs-td>
            <vs-td>
                <p class="mb-1">No. de cuentas asociadas al alumno:<strong> {{tr.usersTotal}}</strong></p>
                <div v-if="tr && tr.users_vinculados[0]">
                    <p class="mb-0">Cuentas asociadas al alumno: </p>
                    <div v-for="(users_vinculados, i) in tr.users_vinculados" :key="i">
                        <p class="mb-0"><span v-if="users_vinculados.username"><strong>{{users_vinculados.username}}</strong></span> ({{users_vinculados.tipoUserPrincipal}})</p>
                    </div> 
                </div>
                

            </vs-td>
            <vs-td>
                <p>{{tr.username}}</p>
            </vs-td>
            <vs-td>
                <p>{{tr.correoRecuperacion}}</p>
            </vs-td>
          </vs-tr>
        </template>
        <template #notFound>
            No hay información
        </template>
        <template #footer>
          <vs-pagination v-model="page" :length="pages" />
        </template>
      </vs-table>
      <acceso-masivo v-model="activeMasivo" :filtros="filtros" @refreshTable="getAccesiMasivoAlumnos"></acceso-masivo>
    </div>
</template>
<script>
import accesibilidad from '../../../../api/requests/accesibilidad'
import AccesoMasivo from './modal/acceso-masivo.vue'
export default {
    props: [
        'ejecutar',
        'filtros',
        'anular'
    ],
    data:() => ({
        page: 1, 
        max: 10,
        pages: 0,
        users: [],
        activeMasivo: false,
        total: ''
    }),
    components: {
        AccesoMasivo
    },
    methods:{
        async getAccesiMasivoAlumnos(){
            const loading = this.$vs.loading()
            try{
                const params = {
                    page: this.page,
                    institucion_id: this.filtros.institucion,
                    ciclo_escolar_id: this.filtros.cicloEscolar,
                }
                
                if(this.filtros.grupo[0] == ''){
                    const eliminar = this.filtros.grupo.shift()
                    params.grupo_id = this.filtros.grupo
                }else{
                    params.grupo_id = this.filtros.grupo
                }
                const {data: response} = await accesibilidad.getAccesiMasivoAlumnos(params)
                loading.close()
                this.users = response.data[0] ? response.data : []
                this.total = response.total
            }
            catch(error){
                console.log(error)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Se produjo un error',
                    text: 'Favor de contactar al adminsitrador'
                })
            }
        }
    },
    watch:{
        ejecutar(){
            this.getAccesiMasivoAlumnos()
        },
        anular(){
            this.users = []
            this.total = ''
        }
    }
}
</script>
<style>
  .tablaAlumnos .vs-table-content .vs-table table{
      margin: 1.7% 0 !important;
      width: 100% !important;
  }
</style>
<style scoped>
    .col-blue {
        background-color: #b5fcc1;
        color: #ffffff;
    }
    
  .divisionLineas:not(:last-child){
      border-bottom: 1px solid #E5E7E9; 
  }
  .divisionLineas{
      padding: 2% 0;
  }
</style>
        